/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * Form 요소 통합 인덱스를 정의한다.
 *
 * @file /src/namespaces/components/Form.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 8. 27.
 */
import { Form as FormBase } from '@components/form/Form';
import { Field as FieldBase } from '@components/form/field/Field';
import { Check as CheckBase } from '@components/form/field/check/Check';
import { Group as RadioGroup } from '@components/form/field/radio/Group';
import { Group as CheckGroup } from '@components/form/field/check/Group';
import { Container } from '@components/form/field/container/Container';
import { Date } from '@components/form/field/date/Date';
import { Period } from '@components/form/field/period/Period';
import { Display } from '@components/form/field/display/Display';
import { Editor } from '@components/form/field/editor/Editor';
import { Hidden } from '@components/form/field/hidden/Hidden';
import { Number } from '@components/form/field/number/Number';
import { Search } from '@components/form/field/search/Search';
import { Select } from '@components/form/field/select/Select';
import { Text } from '@components/form/field/text/Text';
import { TextArea } from '@components/form/field/textarea/TextArea';
import { Theme } from '@components/form/field/theme/Theme';
import { Template } from '@components/form/field/template/Template';
import { File } from '@components/form/field/file/File';
import { Image } from '@components/form/field/image/Image';
import { Set } from '@components/form/field/set/Set';
import { Grid } from '@components/form/field/grid/Grid';
import { Tags } from '@components/form/field/tags/Tags';
import { Color } from '@components/form/field/color/Color';
import { Icon } from '@components/form/field/icon/Icon';
import { Blocks } from '@components/form/field/blocks/Blocks';
import { Time } from '@components/form/field/time/Time';
import { Context } from '@components/form/field/context/Context';
import { Page } from '@components/form/field/page/Page';
import { Include } from '@components/form/field/include/Include';

export class Check extends CheckBase {}
export namespace Check {
    export const Group = CheckGroup;
}

const Radio = { Group: RadioGroup };
const Fields = {
    Check,
    Radio,
    Container,
    Date,
    Period,
    Display,
    Editor,
    Hidden,
    Number,
    Search,
    Select,
    Set,
    Grid,
    Text,
    TextArea,
    Theme,
    Template,
    File,
    Image,
    Tags,
    Color,
    Icon,
    Blocks,
    Time,
    Context,
    Page,
    Include,
};

export type Field = {
    Field: { new (): FieldBase };
};

export class Form extends FormBase {}
export namespace Form {
    export const Field = Fields;
}
